import { Editor } from '@tinymce/tinymce-react';
import { useRef } from 'react';

const RichTextArea = ({ value, onChange }) => {
  const editorRef = useRef(null);
  return (
    <Editor
      apiKey='5l2eqpfh2fhd721r2qr1v3yyzwwwkpjne04pvb7t1xysvkuu'
      onInit={(evt, editor) => (editorRef.current = editor)}
      value={value}
      onEditorChange={onChange}
      init={{
        height: 500,
        menubar: false,
        plugins: [
          'advlist',
          'autolink',
          'lists',
          'link',
          'image',
          'charmap',
          'preview',
          'anchor',
          'searchreplace',
          'visualblocks',
          'code',
          'fullscreen',
          'insertdatetime',
          'media',
          'table',
          'code',
          'help',
          'wordcount',
        ],
        toolbar:
          'undo redo | blocks | ' +
          'bold italic forecolor | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'removeformat | help',
        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      }}
    />
  );
};

RichTextArea.defaultProps = {
  // value: '',
  onChange: () => {},
};

export default RichTextArea;
